export default "__VITE_ASSET__D$VBkO4D__"